import {
  Component,
  OnInit,
  Renderer2,
  Injector,
  ChangeDetectorRef,
} from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Login } from './login';
import { LoginService } from './login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LoaderService } from '../../loader/loader.service';
import { SharedsService } from 'src/app/shareds/shareds.service';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentService } from 'src/app/environment.service';
declare const window: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  user: Login = {
    username: '',
    password: '',
    browser_details: null,
    timeZone: '',
    lang: '',
  };
  error: { message: string; status: boolean } = {
    message: 'Sorry, Something went wrong.',
    status: false,
  };
  status: { status: string; token: any };
  dialogRef: MatDialogConfig;
  forgotPasswordSubmitted = false;
  email = '';
  submitted = false;
  showLogin = true;
  config: any = {
    displayKey: 'title',
    search: true,
    height: 'auto',
    placeholder: 'Select',
    customComparator: () => {
      // Do Nothing
    },
    limitTo: 10,
    moreText: 'more',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'Language',
  };
  languageList: any = [
    {
      id: 'en',
      title: 'English',
    },
    {
      id: 'ar',
      title: 'Arabic',
    },
  ];
  defaultLanguage: any = 'en';
  sharedService: SharedsService;
  loader: LoaderService;
  loginService: LoginService;
  translate: TranslateService;
  googleError = '';
  linkedinParams = {};
  linkedInToken: any;
  ssoEnabled = false;
  googleParams: { client_id: string; redirect_uri: string };

  constructor(
    private readonly deviceService: DeviceDetectorService,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly injector: Injector,
    private readonly toastr: ToastrService,
    private readonly renderer: Renderer2,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly envService: EnvironmentService,
  ) {
    this.ssoEnabled = this.envService.read('ssoEnabled');
    this.sharedService = this.injector.get<SharedsService>(SharedsService);
    this.loader = this.injector.get<LoaderService>(LoaderService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.translate = this.injector.get<TranslateService>(TranslateService);
    this.translate.setDefaultLang('en');
    this.translate.use(this.defaultLanguage ? this.defaultLanguage : 'en');
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.type === 'click') {
        if ((e.target as HTMLInputElement).id === 'signup') {
          //
        } else if ((e.target as HTMLInputElement).id === 'forgetpassword') {
          this.showLogin = false;
        } else if ((e.target as HTMLInputElement).id === 'mainDiv') {
          this.updateVariable();
        } else if (
          (e.target as HTMLInputElement).className ===
          'cdk-overlay-backdrop cdk-overlay-dark-backdrop'
        ) {
          this.updateVariable();
        } else {
          // Do Nothings
        }
      }
    });
  }

  ngOnInit() {
    window.sendIdTokenToServer = this.sendIdTokenToServer.bind(this);
    this.setBrowserDetails();
    this.setSOSCredentials();
    localStorage.setItem('Language', this.defaultLanguage);
  }

  setSOSCredentials() {
    if (this.ssoEnabled) {
      const uiURL = window.location?.origin || 'https://unified.ai';
      this.linkedinParams = {
        response_type: 'code',
        client_id: '86rwkxhx5lxdg8', // '86p95kwk79w4vo',
        redirect_uri: `${uiURL}/login`,
        state: 'linkedin',
        scope: 'openid, email', // Adjust scopes as needed
      };
      this.googleParams = {
        client_id:
          '914067849245-4fuulnaodra6ejquu4dlplg6e6evh3ci.apps.googleusercontent.com',
        // client_id: "53719461969-a17bmh7gp8hkca4fntugdmn1u4uesrs2.apps.googleusercontent.com", // NOSONAR
        redirect_uri: `${uiURL}/login`,
      };
      const code = this.route.snapshot.queryParams['code'];
      const state = this.route.snapshot?.queryParams?.state;
      if (state === 'google' || state === 'google_signup') {
        this.sendIdTokenToServer(code, state);
      } else if (state === 'linkedin') {
        this.linkedInToken = code;
        this.validateLinkedInLogin();
      }
    }
  }

  updateVariable() {
    this.showLogin = true;
  }

  sign_in(user: Login): void {
    user.username = user.username.trim().toLowerCase();
    user.password = user.password.trim();
    user.timeZone = this.sharedService.timeZone;
    user.lang = this.defaultLanguage;
    this.user = user;
    this.loginService.login(this.user).subscribe((data) => {
      this.loader.display(false);
      this.error.status = false;
      if (data?.success) {
        this.handleLoginSignUp(data);
      } else {
        this.error.status = true;
        this.error.message = data.message
          ? data.message
          : this.translate.instant('toastr.something_wrong');
        this.toastr.error('', this.error.message);
      }
    });
  }

  handleLoginSignUp(data) {
    this.setValues(data);
    const redirectUrl = this.loginService.redirectUrl
      ? this.loginService.redirectUrl
      : environment.dashboardPrefix + data.user_data.roles.menu_tab[0].path;
    const userData = JSON.parse(localStorage.getItem('user'))
      ? JSON.parse(localStorage.getItem('user'))
      : {};
    const channels = userData.channels ? userData.channels : '';
    let request_from_apple = false;
    if (userData?.appSettings?.projectDetail?.request_from_apple) {
      request_from_apple =
        userData?.appSettings?.projectDetail?.request_from_apple;
    }
    if (
      data.user_data.multiAppLogin ||
      (channels && channels.length === 0 && request_from_apple)
    ) {
      this.router.navigate(['apps']);
    } else {
      this.status = {
        status: 'active',
        token: data.user_data.token,
      };
      this.sharedService
        .AgentOnlineStatus(this.status)
        .subscribe((response) => {});
      this.router.navigate([redirectUrl]);
    }
  }

  setValues(data) {
    const theme = data.user_data?.['appSettings']?.['projectDetail']?.theme;
    localStorage.setItem('theme', theme || 'black-style.css');
    sessionStorage.setItem('loggedin', 'true');
    const allowedAppIds = data.user_data?.appid;
    if (data.user_data?.appid?.length > 0) {
      data.user_data.appid = data.user_data.appid[0];
    }
    data.user_data.wabaAccounts = data?.user_data?.['appSettings'][
      'projectDetail'
    ]['wabaAccounts']
      ? data.user_data['appSettings']['projectDetail']['wabaAccounts']
      : [];
    localStorage.setItem('user', JSON.stringify(data.user_data));
    localStorage.setItem('allowedAppIds', allowedAppIds);
    if (data.user_data.companyNameLogoUrl) {
      localStorage.setItem(
        'companyNameLogoUrl',
        JSON.stringify(data.user_data.companyNameLogoUrl),
      );
    }
    if (data.user_data.companyName) {
      localStorage.setItem(
        'companyName',
        JSON.stringify(data.user_data.companyName),
      );
    }

    localStorage.setItem('access-token', JSON.stringify(data.user_data.token));

    this.sharedService.appId = data?.user_data?.appid ?? '';
    this.sharedService.token = data?.user_data?.token ?? '';

    sessionStorage.setItem('appid', this.sharedService.appId);

    if (data.user_data.companyNameLogoUrl) {
      localStorage.setItem(
        'companyNameLogoUrl',
        JSON.stringify(data.user_data.companyNameLogoUrl),
      );
    }
    if (data.user_data.companyName) {
      localStorage.setItem(
        'companyName',
        JSON.stringify(data.user_data.companyName),
      );
    }
    if (data.user_data.name) {
      localStorage.setItem('name', JSON.stringify(data.user_data.name));
    }
    if (data.user_data.address) {
      localStorage.setItem('address', JSON.stringify(data.user_data.address));
    }
  }

  setBrowserDetails() {
    this.user.browser_details = this.deviceService.getDeviceInfo();
  }

  showTemplateSignUp() {
    this.router.navigate(['signup']);
  }

  showTemplate(TemplateRef) {
    this.showLogin = false;
    this.dialogRef = this.dialog.open(TemplateRef, {
      panelClass: 'dialog-container-custom',
      width: '650px !important',
    });
  }

  submitForgotPassword() {
    this.loader.display(true);
    this.forgotPasswordSubmitted = true;
    if (this.email === '' || this.email === null) {
      this.loader.display(false);
      return;
    }

    const args = {
      email: this.email.trim(),
    };
    this.loginService.forgotPassword(args).subscribe(
      (data) => {
        if (data.status === 404) {
          this.loader.display(false);
          this.toastr.error(data.info);
          this.email = '';
          this.forgotPasswordSubmitted = false;
        } else if (data.status !== 200) {
          this.toastr.error(
            this.translate.instant('toastr.error_resetlink_sent'),
          );
          this.loader.display(false);
          this.email = '';
          this.forgotPasswordSubmitted = false;
        } else {
          this.toastr.success(this.translate.instant('toastr.resetlink_sent'));
          this.loader.display(false);
          this.email = '';
          this.forgotPasswordSubmitted = false;
          this.dialog.closeAll();
        }
        this.showLogin = true;
      },
      (error) => {
        this.toastr.error(this.translate.instant('toastr.error_passwordLink'));
        this.loader.display(false);
        this.email = '';
        this.forgotPasswordSubmitted = false;
        this.showLogin = true;
      },
    );
  }

  onCancel() {
    this.dialog.closeAll();
    this.showLogin = true;
    this.email = '';
    this.forgotPasswordSubmitted = false;
  }

  changeLanguage(event) {
    this.defaultLanguage = event.value.id;
    localStorage.setItem('Language', this.defaultLanguage);
    this.translate.use(event.value.id);
  }

  sendIdTokenToServer(googleUser, state) {
    this.googleError = '';
    const idToken = googleUser;
    const arg = { idToken, type: state };
    if (idToken) {
      this.loginService.sendGoogleToken(arg).subscribe((data) => {
        this.error.status = false;
        if (data?.success) {
          this.loader.display(false);
          this.handleLoginSignUp(data);
        } else {
          const error = data.message ?? 'Sorry something went wrong';
          this.toastr.error('', error);
          console.log('error', error);
          this.googleError = error;
          this.loader.display(false);
          this.cdr.detectChanges();
          this.router.navigate(['.'], {
            relativeTo: this.route,
            queryParams: {},
          });
        }
      });
    } else {
      this.loader.display(false);
      this.toastr.error('', this.translate.instant('toastr.something_wrong'));
      this.cdr.detectChanges();
    }
  }

  validateLinkedInLogin() {
    console.log('Login linkedInToken', this.linkedInToken);
    this.loader.display(true);
    this.loginService
      .sendLinkedinToken({ code: this.linkedInToken })
      .subscribe((data) => {
        this.loader.display(false);
        this.error.status = false;
        if (data?.success) {
          this.handleLoginSignUp(data);
        } else {
          this.router.navigateByUrl('/login');
          const error = data.message
            ? data.message
            : this.translate.instant('toastr.something_wrong');
          this.googleError = error;
          this.toastr.error('', error);
        }
      });
  }

  loginUsingLinkedIn() {
    window.location.href = `https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=${this.linkedinParams['client_id']}&redirect_uri=${this.linkedinParams['redirect_uri']}&state=${this.linkedinParams['state']}&scope=email,openid`;
  }

  loginUsingGoogle() {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${this.googleParams['client_id']}&redirect_uri=${this.googleParams['redirect_uri']}&response_type=code&scope=profile email&state=google&prompt=select_account`;
  }
  // paymentLik(planId) {
  //   this._settingsService.initializeStripe();
  //   const arg = {
  //     planId: planId,
  //   }
  //   this._settingsService.createCheckoutSession(arg).subscribe(async (response) => {
  //     if (response?.info?.['sessionId']) {
  //       this.loader.display(false);
  //       await this._settingsService.redirectToCheckout(response.info['sessionId']);
  //     } else {
  //       this.loader.display(false);
  //       this.toastr.error(response.info);
  //     }
  //   });
  // }
}
